<template>
  <div class="bfi-group bfi-card">
    <div class="bfi-container">
      <div class="bfi">
        <svg
          width="90"
          height="89"
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 80 80"
        >
          <circle class="cls-3" cx="40" cy="40" r="40"/>
          <g>
            <g id="Atoms_icons_40_grey-red_asistencne_sluzby" data-name="Atoms/icons/40/grey-red/asistencne_sluzby">
              <g id="Group">
                <rect class="cls-2" x="31.2" y="14.76" width="17.75" height="24" rx="7.97" ry="7.97"/>
                <path class="cls-2" d="M62.26,65.94H17.74l1.26-15.01c.54-6.42,6.07-11.37,12.71-11.37h15.93c7.17,0,13.12,5.39,13.62,12.34l1,14.05Z"/>
                <line id="Stroke-9" class="cls-2" x1="53.31" y1="49.34" x2="53.31" y2="65.22"/>
                <line id="Stroke-11" class="cls-2" x1="61.83" y1="59.93" x2="53.31" y2="59.93"/>
                <line id="Stroke-9-2" data-name="Stroke-9" class="cls-2" x1="26.85" y1="49.34" x2="26.85" y2="65.22"/>
                <line id="Stroke-11-2" data-name="Stroke-11" class="cls-2" x1="26.85" y1="59.93" x2="18.25" y2="59.93"/>
                <path class="cls-1" d="M31.2,21.68l.05-2.86c0-2.65,2.12-4.76,4.94-4.76h7.94c2.65,0,4.76,2.12,4.76,4.76l.05,2.91-17.75-.05Z"/>
                <path id="Stroke-28" class="cls-2" d="M45.37,31.7c-1.23,1.06-3.18,1.76-5.29,1.76s-4.06-.71-5.29-1.76"/>
                <circle class="cls-2" cx="35.48" cy="25.36" r=".7"/>
                <circle class="cls-2" cx="44.67" cy="25.36" r=".7"/>
              </g>
            </g>
            <circle class="cls-1" cx="34.34" cy="52.43" r="3.09"/>
            <path class="cls-1" d="M40.89,50.39c.9-3.18,3.57-5.21,5.96-4.53,2.39.68,3.59,3.81,2.69,6.99"/>
            <path class="cls-1" d="M34.34,49.34s-2.13-5.85-1.96-10.58"/>
            <path class="cls-1" d="M46.96,45.17s1.06-3.57.98-6.46"/>
          </g>
        </svg>

        <p class="bfi-title">
          Availability of doctors
        </p>
        <p class="bfi-desc">
          We have more than 21,500 doctors throughout Slovakia
        </p>
      </div>
    </div>

    <div class="bfi-container">
      <div class="bfi">
        <svg
          width="90"
          height="89"
          viewBox="0 0 90 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="45"
            cy="44.5"
            r="44.5"
            fill="#F1F1F1"
          />
          <rect
            x="30.5"
            y="19"
            width="28.028"
            height="7.546"
            rx="1.54"
            fill="white"
          />
          <path
            d="M26.5 36.8008H62.5V62.9508C62.5 65.0771 60.7763 66.8008 58.65 66.8008H30.35C28.2237 66.8008 26.5 65.0771 26.5 62.9508V36.8008Z"
            stroke="#747474"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M26.5 36.8008H62.5V62.9508C62.5 65.0771 60.7763 66.8008 58.65 66.8008H30.35C28.2237 66.8008 26.5 65.0771 26.5 62.9508V36.8008Z"
            fill="white"
            stroke="#747474"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M62.5 37L26.5 37L26.5 30.85C26.5 28.7237 28.2237 27 30.35 27L58.65 27C60.7763 27 62.5 28.7237 62.5 30.85L62.5 37Z"
            fill="white"
            stroke="#747474"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="30.6094"
            y="19"
            width="28.028"
            height="7.546"
            rx="1.54"
            stroke="#747474"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M49.5852 44.4413H47.2114V42.0676C47.2114 41.2354 46.5366 40.5605 45.7044 40.5605H43.5441C42.7119 40.5605 42.0371 41.2354
            42.0371 42.0676V44.4413H39.6611C38.8311 44.4413 38.1562 45.114 38.1562 45.9484V48.1087C38.1562 48.9409 38.8311 49.6157
            39.6611 49.6157H42.0371V51.9895C42.0371 52.8217 42.7119 53.4965 43.5441 53.4965H45.7044C46.5366 53.4965 47.2114 52.8217
            47.2114 51.9895V49.6157H49.5852C50.4174 49.6157 51.0922 48.9409 51.0922 48.1087V45.9484C51.0922 45.114 50.4174 44.4413 49.5852 44.4413Z"
            fill="#8EC63E"
          />
          <path
            d="M26.5 59.3008H62.5"
            stroke="#747474"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M54.796 63.5151C53.1109 63.836 51.3412 63.0825 50.4312 61.5089C50.1077 60.9233 49.922 60.3269 49.8741 59.7196C49.7525 58.1779
            50.5038 56.5674 51.9186 55.7507L63.713 48.8035C65.6993 47.6127 68.2501 48.3047 69.4265 50.3273C69.7004 50.8698 69.8862 51.4662
            69.9341 52.0736C70.0556 53.6152 69.3043 55.2258 67.8895 56.0424L61.5743 59.784"
            fill="white"
          />
          <path
            d="M54.796 63.5151C53.1109 63.836 51.3412 63.0825 50.4312 61.5089C50.1077 60.9233 49.922 60.3269 49.8741 59.7196C49.7525 58.1779
            50.5038 56.5674 51.9186 55.7507L63.713 48.8035C65.6993 47.6127 68.2501 48.3047 69.4265 50.3273C69.7004 50.8698 69.8862 51.4662
            69.9341 52.0736V52.0736C70.0556 53.6152 69.3043 55.2258 67.8895 56.0424L61.5743 59.784"
            stroke="#8EC63E"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M77.0666 64.0769C77.0983 66.2595 75.372 68.1158 73.1852 68.2883C73.0922 68.2956 72.9991 68.303 72.9061 68.3103L59.1505
            68.4188C56.8095 68.4174 54.9313 66.5664 54.8924 64.2914C54.8778 64.1065 54.9098 63.9181 54.9454 63.7758C55.1645 61.8058
            56.8233 60.2803 58.7774 60.1262C58.8705 60.1188 58.9635 60.1115 59.1031 60.1005L61.8163
            60.0725L72.9052 59.9884C75.1458 59.9046 77.0705 61.752 77.0666 64.0769Z"
            fill="white"
            stroke="#8EC63E"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <p class="bfi-title">
          Cheaper Medication
        </p>
        <p class="bfi-desc">
          Unlimited Benefits on Medication and Dietetic Foods for Children Under 18
        </p>
      </div>
    </div>

    <div class="bfi-container">
      <div class="bfi">
        <svg
          width="90"
          height="89"
          viewBox="0 0 90 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="45"
            cy="44.5"
            r="44.5"
            fill="#F1F1F1"
          />
          <path
            d="M15.8675 45.5338C15.857 45.5224 15.8467 45.5111 15.8366 45.5C15.8467 45.4889 15.857 45.4776 15.8675 45.4662C16.2701 45.0262
            16.8673 44.3941 17.6383 43.6339C19.1812 42.1124 21.4145 40.0833 24.1721 38.0556C29.709 33.9843 37.2492 30 45.5 30C53.7508 30
            61.291 33.9843 66.8279 38.0556C69.5855 40.0833 71.8188 42.1124 73.3617 43.6339C74.1327 44.3941 74.7299 45.0262 75.1325
            45.4662C75.143 45.4776 75.1533 45.4889 75.1634 45.5C75.1533 45.5111 75.143 45.5224 75.1325 45.5338C74.7299 45.9738 74.1327
            46.6059 73.3617 47.3661C71.8188 48.8876 69.5855 50.9167 66.8279 52.9444C61.291 57.0157 53.7508 61 45.5 61C37.2492 61 29.709
            57.0157 24.1721 52.9444C21.4145 50.9167 19.1812 48.8876 17.6383 47.3661C16.8673 46.6059 16.2701 45.9738 15.8675 45.5338Z"
            fill="white"
            stroke="#747474"
            stroke-width="2"
          />
          <circle
            cx="45.5"
            cy="45.5"
            r="9"
            stroke="#8EC63E"
            stroke-width="7"
          />
          <path
            d="M16.7071 32.2929C16.3166 31.9024 15.6834 31.9024 15.2929 32.2929C14.9024 32.6834 14.9024 33.3166
            15.2929 33.7071L16.7071 32.2929ZM23.2071 38.7929L16.7071 32.2929L15.2929 33.7071L21.7929 40.2071L23.2071 38.7929Z"
            fill="#747474"
          />
          <path
            d="M73.2929 32.2929C73.6834 31.9024 74.3166 31.9024 74.7071 32.2929C75.0976 32.6834 75.0976 33.3166
            74.7071 33.7071L73.2929 32.2929ZM66.7929 38.7929L73.2929 32.2929L74.7071 33.7071L68.2071 40.2071L66.7929 38.7929Z"
            fill="#747474"
          />
          <path
            d="M57.2137 22.7273C57.3643 22.196 57.9171 21.8873 58.4485 22.0379C58.9798 22.1885 59.2885 22.7413
            59.1379 23.2727L57.2137 22.7273ZM54.707 31.5713L57.2137 22.7273L59.1379 23.2727L56.6312 32.1167L54.707 31.5713Z"
            fill="#747474"
          />
          <path
            d="M33.6301 22.7273C33.4795 22.196 32.9266 21.8873 32.3953 22.0379C31.8639 22.1885 31.5553 22.7413
            31.7059 23.2727L33.6301 22.7273ZM36.1367 31.5713L33.6301 22.7273L31.7059 23.2727L34.2125 32.1167L36.1367 31.5713Z"
            fill="#747474"
          />
        </svg>

        <p class="bfi-title">
          Vision Package
        </p>
        <p class="bfi-desc">
          Benefits Package Worth €150 for a Comprehensive Eye Examination, Additional Care and for Purchasing Glasses
        </p>
      </div>
    </div>

    <a
      class="bfi-end-text"
      target="_blank"
      href="https://www.union.sk/vyhody-pre-poistencov/"
    >
      See All Benefits and Discounts
    </a>
  </div>
</template>

<script>
export default {
  name: 'BenefitInformation',
};
</script>

<style lang="scss" scoped>
.cls-1 {
  stroke: #8ec63e;
}

.cls-1, .cls-2 {
  fill: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}

.cls-3 {
  fill: #f1f1f1;
  stroke-width: 0px;
}

.cls-2 {
  stroke: #747474;
}
</style>
